export const convertDateTimeBr = (dateString: string) => { 
    const date = new Date(dateString);
    date.setHours(date.getHours() - 3)
    return date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
};

export const convertDateTime = (dateString: string) => { 
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
};

export const convertDateBr = (dateString: string) => { 
    const date = new Date(dateString);
    date.setHours(date.getHours() - 3)
    return date.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
};

export const convertDate = (dateString: string) => { 
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
};

export const convertDateTimeTimestamp = (timestamp: number) => { 
    const date = new Date(timestamp * 1000);
    date.setHours(date.getHours());
    return date.toLocaleString('pt-BR');
}